import React from 'react';
import he from "he";
import clsx from "clsx";
import EasyCalEvent from './EasyCalEvent';

// const EasyCalEventWrapper = ({children, event, style }) => {
const EasyCalEventWrapper = (props: EventWrapperProps) => {

  const {
    view,
    locationLookup
  } = props;

  const locationName = locationLookup[props.event.location] || 'Unknown Location';

  const {
    height = 'initial', // Fallback to 0 if undefined
    top = 'initial',    // Fallback to 0 if undefined
    width = 'initial',  // Fallback to 0 if undefined
    xOffset = 'initial', // Fallback to 0 if undefined
    ...restStyle // Capture other style properties
  } = props.style || {}; // Ensure props.style is an object

  const customStyle = {
    ...restStyle,
    height: `${height}%`, // Convert height to percentage
    top: `${top}%`,       // Convert top to percentage
    width: `${width}%`,   // Convert width to percentage
    left: `${xOffset}%`,  // Convert xOffset to percentage
  };

  const eventClass = clsx('rbc-event easycal-view loc-'+props.event.location + ' view-'+view, {
    // 'rbc-selected': selected,
    'rbc-event-allday': props.event.allDay,
    'rbc-event-continues-prior': props.continuesPrior,
    'rbc-event-continues-after': props.continuesAfter,
  });

  const handleEventClick = (e) => {
    if(props.onClick)
      props.onClick(props.event);
    if(props.onSelect)
      props.onSelect(props.event);
  };

  // if(view == 'week')
  //   return(
  //     <div 
  //       style={customStyle}
  //       className={eventClass} 
  //       role="button" 
  //       title={props.event.title}
  //       onClick={handleEventClick} // Add onClick handler
  //     >
  //     {/* <div className={eventClass} role="button"> */}
  //         {/* {props.children} */}
  //         <div className='rbc-event-label week-label'>{locationName}</div>
  //         <div className='rbc-event-content' title={props.event.title}>
  //           <EasyCalEvent event={props.event} title={props.event.title} continuesPrior={props.continuesPrior} continuesAfter={props.continuesAfter} isAllDay={props.event.allDay} view={view}/>
  //         </div>
  //     </div>
  //   )
  // else 
    return (
      <div 
        style={customStyle}
        className={eventClass} 
        role="button" 
        title={props.event.title}
        onClick={handleEventClick} // Add onClick handler
      >
      {/* <div className={eventClass} role="button"> */}
          {/* {props.children} */}
          <div className='rbc-event-label'>{props.label}</div>
          <div className='rbc-event-content' title={props.event.title}>
            <EasyCalEvent event={props.event} title={props.event.title} continuesPrior={props.continuesPrior} continuesAfter={props.continuesAfter} isAllDay={props.event.allDay}/>
          </div>
      </div>
    )
}

export default EasyCalEventWrapper